import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '@/App';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { BookOpen } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const JournalPage = () => {
  const navigate = useNavigate();
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadEntries();
  }, []);

  const loadEntries = async () => {
    try {
      const response = await axios.get(`${API}/journal`, { withCredentials: true });
      setEntries(response.data);
    } catch (error) {
      toast.error('Failed to load journal entries');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Loading journal...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="flex items-center justify-between mb-8">
          <h1 className="text-4xl" style={{ fontFamily: 'Playfair Display, serif' }} data-testid="journal-title">
            My Journal
          </h1>
          <Button variant="outline" onClick={() => navigate('/dashboard')} data-testid="back-btn">
            Back
          </Button>
        </div>

        {entries.length === 0 ? (
          <div className="text-center py-16" data-testid="empty-journal">
            <BookOpen className="w-16 h-16 mx-auto mb-4 text-muted-foreground opacity-50" strokeWidth={1.5} />
            <p className="text-muted-foreground mb-4">No journal entries yet</p>
            <Button onClick={() => navigate('/dashboard')} data-testid="start-writing-btn">
              Start Writing
            </Button>
          </div>
        ) : (
          <div className="space-y-6" data-testid="journal-entries">
            {entries.map((entry) => (
              <Card key={entry.entry_id} className="p-6 border border-primary/10" data-testid={`journal-entry-${entry.entry_id}`}>
                <p className="text-sm text-muted-foreground mb-4">
                  {new Date(entry.created_at).toLocaleDateString('en-US', { 
                    year: 'numeric', 
                    month: 'long', 
                    day: 'numeric' 
                  })}
                </p>
                <p className="text-muted-foreground leading-relaxed whitespace-pre-line">
                  {entry.response}
                </p>
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default JournalPage;